import { instance } from './instance'

export default class AuthApi {
  static async login(data: { password: string; email: string }) {
    return await instance.post('/auth/login', data)
  }
}
